import React from 'react';
import { Fragment, useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthComponent } from '../components/auth/AuthComponent';
import { TestHello } from '../containers/Test';
import { CircularProgress } from '@mui/material';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
import { Users } from '../containers/Users';
import { useDispatch, useSelector } from 'react-redux';
import { Teams } from '../containers/Teams';
import { checkAuth } from '../actions/auth';
import { setUser } from '../actions/user';
import { ClientsRegister } from '../containers/ClientsRegister';
import { Clients } from '../containers/Clients';
import { ClientsRegisterLocal } from '../containers/ClientsRegisterLocal';
import { ClientProfile } from '../components/clients/ClientProfile';
import { Orders } from '../containers/Orders';
import { BiasProfile } from '../components/orders/BiasProfile';
import { NewOrderForm2 } from '../components/orders/NewOrderForm2';
import { NewSubBiasForm } from '../components/orders/NewSubBiasForm';
import Areas from '../containers/Areas';
import { AreasForm } from '../components/areas/AreasForm';
import { NewBiasForm4 } from '../components/orders/NewBiasForm4';
import { OrderTracking } from '../containers/OrderTracking';
import { setSideBarStatus } from '../actions/sidebar';
import { WorkspaceNew } from '../components/orders/workspace/WorkspaceNew';
import { getAndSetCurrentVersion } from '../actions/version';
import { QuotationForm } from '../components/quotationEngine/QuotationForm';
import { SummaryResults } from '../components/orders/SummaryResults';
import { SummaryResultsIncidents } from '../components/incidents/SummaryResultsIncidents';
import { setNavBarStatus } from '../actions/ui';
import { Tests } from '../components/tests/Tests';
import Dashboard from '../components/dashboard/dashboard/Dashboard';
import { AddProspect } from '../components/prospects/addProspect/AddProspect';
import { DashboardMobile } from '../components/dashboard/dashboard/DashboardMobile';
import { OrdersTable3 } from '../components/orders/OrdersTable3';
import { ProvidersTable } from '../components/providers/ProvidersTable';
import { ProviderForm } from '../components/providers/ProviderForm';
import { ExternalTolling } from '../components/externalTolling/ExternalTolling';
import { ExternalTollingTable } from '../components/externalTolling/ExternalTollingTable';
import { NewTicketForm } from '../components/tickets/NewTicketForm';
import { ProductionPlan } from '../components/productionPlan/ProductionPlan';
import { TicketsCatalog } from '../components/tickets/TicketsCatalog';
import { TIcketDetail } from '../components/tickets/TicketDetail';
import { LoginTracking } from '../components/landing/pagesLanding/LoginTracking';
import { LandingTracking } from '../components/landing/LandingTracking';
import { HomeTracking } from '../components/landing/pagesLanding/HomeTracking';
import { MyOrders } from '../components/landing/pagesLanding/MyOrders';
import { ProspectionsTable } from '../components/prospects/ProspectionsTable';
import { EditProspecting } from '../components/prospects/editProspecting/EditProspecting';
import { whichEnvURL, whichPath } from '../helpers/utils';

export const AppRouter = () => {
    const [checking, setsChecking] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const { token } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Base path
    const basePath = whichPath();
    const env = whichEnvURL(true);

    const handlePath = user => {
        // Define new path
        let path = '';

        // Client path
        if (user?.is_client) {
            // Define client path
            path = '/tracking/mis-pedidos';
        }
        // Internal user path
        else {
            // Get last path if any
            const lastPath = localStorage.getItem('lastPathPilu');
            // Define new path
            path = lastPath;

            if (
                lastPath === 'null' ||
                !lastPath ||
                lastPath?.includes('/dashboard/order/') ||
                lastPath?.includes('/editar-orden/')
            ) {
                path = '/dashboard/ordenes';
            }
        }

        // Set/Reset new items in local storage
        localStorage.setItem('lastPathPilu', path);
        localStorage.setItem('lastTablePage', 1);
        localStorage.setItem('lastOrdersTablePath', 'null');

        // Navigate to the new path
        navigate(path);
    };

    useEffect(() => {
        // Start 'checking'
        setsChecking(true);
        // Check authentication
        checkAuth(token)
            .then(user => {
                // Finish 'checking'
                setsChecking(false);
                if (user) {
                    // Set user info
                    dispatch(setUser(user));
                    // Set loggin to true
                    setIsLoggedIn(true);
                    // Set sidebar status
                    setSideBarStatus();
                    // Set navbar theme status
                    setNavBarStatus();
                    if (!user?.is_client) {
                        // Current version
                        getAndSetCurrentVersion();
                    }
                    // Redirect last saved path
                    handlePath(user);
                } else {
                    // Clear consolo
                    console.clear();
                    // Reset login state
                    setIsLoggedIn(false);
                    // Check if last session was a user client
                    const isUserClient =
                        localStorage.getItem('is_client') === 'true';
                    
                    // Redirect
                    if (isUserClient) {
                        window.location.href = basePath + (env !== 'stage' ? '/#' : '') + '/tracking/inicio-de-sesion';
                    } else {
                        navigate('/auth/inicio-de-sesion');
                    }
                }
            })
            .catch(() => {
                // Finish 'checking'
                setsChecking(false);
            });
        console.log('App Router ✅');
    }, [token]);

    if (checking) {
        return (
            <center style={{ padding: '20%' }}>
                <CircularProgress />
            </center>
        );
    }

    return (
        <Fragment>
            <Routes>
                {/* Private */}
                <Route
                    exact
                    path='/'
                    element={<PrivateRoute isAuthenticated={isLoggedIn} />}
                >
                    {/* Dashboard */}
                    <Route exact path="/" element={<Dashboard />} />

                    {/* Prospects */}
                    <Route
                        exact
                        path='/prospecciones'
                        element={<ProspectionsTable />}
                    />

                    {/* New prospecting */}
                    <Route
                        exact
                        path='/nueva-prospeccion'
                        element={<AddProspect />}
                    />

                    {/* Edit prospecting */}
                    <Route
                        exact
                        path='/editar-prospeccion/:id'
                        element={<EditProspecting />}
                    />

                    {/* Dashboard */}
                    <Route
                        exact
                        path='/dashboard-mobile'
                        element={<DashboardMobile />}
                    />

                    {/* Tests */}
                    <Route
                        exact
                        path='/dashboard/test'
                        element={<TestHello />}
                    />

                    {/* Users */}
                    <Route
                        exact
                        path='/dashboard/usuarios'
                        element={<Users />}
                    />

                    {/* Pruebas */}
                    <Route
                        exact
                        path='/dashboard/pruebas'
                        element={<TestHello />}
                    />

                    {/* Catalogs */}
                    <Route
                        exact
                        path='/dashboard/catalogos'
                        element={<Teams />}
                    />

                    {/* Clients */}
                    <Route
                        exact
                        path='/dashboard/clientes'
                        element={<Clients />}
                    />

                    {/* Client info */}
                    <Route
                        exact
                        path='/dashboard/cliente/:idClient'
                        element={<ClientProfile />}
                    />

                    {/* New client */}
                    <Route
                        exact
                        path='/dashboard/nuevo-cliente'
                        element={<ClientsRegisterLocal />}
                    />

                    {/* Edit client */}
                    <Route
                        exact
                        path='/dashboard/editar-cliente'
                        element={<ClientsRegisterLocal />}
                    />

                    {/* Provider */}
                    <Route
                        exact
                        path='/dashboard/proveedores'
                        element={<ProvidersTable />}
                    />

                    {/* New Provider */}
                    <Route
                        exact
                        path='/dashboard/nuevo-proveedor'
                        element={<ProviderForm />}
                    />

                    {/* Provider read only */}
                    <Route
                        exact
                        path='/dashboard/detalle-proveedor'
                        element={<ProviderForm readOnly />}
                    />

                    {/* Edit Provider */}
                    <Route
                        exact
                        path='/dashboard/editar-proveedor'
                        element={<ProviderForm edit />}
                    />

                    {/* Edit client */}
                    <Route
                        exact
                        path='/dashboard/editar-orden/:idOrder'
                        element={<NewOrderForm2 edit />}
                    />

                    {/* Orders */}
                    <Route
                        exact
                        path='/dashboard/ordenes'
                        element={<Orders />}
                    />

                    {/* External tolling table */}
                    <Route
                        exact
                        path='/dashboard/solicitudes-de-maquila-externa'
                        element={<ExternalTollingTable />}
                    />

                    {/* External tolling */}
                    <Route
                        exact
                        path='/dashboard/maquila-externa'
                        element={<ExternalTolling />}
                    />

                    {/* External tolling readonly */}
                    <Route
                        exact
                        path='/dashboard/maquila-externa/:idETR'
                        element={<ExternalTolling readonly />}
                    />

                    {/* External tolling readonly reception */}
                    <Route
                        exact
                        path='/dashboard/maquila-externa-recepcion/:idETR'
                        element={<ExternalTolling readonly edit reception />}
                    />

                    {/* External tolling edit */}
                    <Route
                        exact
                        path='/dashboard/editar/maquila-externa/:idETR'
                        element={<ExternalTolling edit />}
                    />

                    {/* Summary results */}
                    <Route
                        exact
                        path='/dashboard/resumen-de-resultados'
                        element={<SummaryResults />}
                    />

                    {/* Summary results */}
                    <Route
                        exact
                        path='/dashboard/resumen-de-rechazos'
                        element={<SummaryResultsIncidents />}
                    />

                    {/* Quotations */}
                    <Route
                        exact
                        path='/dashboard/cotizaciones'
                        element={<OrdersTable3 quotation />}
                    />

                    {/* New order */}
                    <Route
                        exact
                        path='/dashboard/nueva-orden/:orderType'
                        element={<NewOrderForm2 />}
                    />

                    {/* Orden info */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder'
                        element={<OrderTracking />}
                    />

                    {/* Workspace/Repository */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder/files'
                        element={<WorkspaceNew />}
                    />

                    {/* Bias info */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder/bias/:idBias'
                        element={<BiasProfile />}
                    />

                    {/* New bias */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder/new-bias'
                        element={<NewBiasForm4 />}
                    />

                    {/* Edit bias */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder/edit-bias/:idBias'
                        element={<NewBiasForm4 edit />}
                    />

                    {/* New subbias */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder/bias/:idBias/new-subbias'
                        element={<NewSubBiasForm />}
                    />

                    {/* Edit subbias */}
                    <Route
                        exact
                        path='/dashboard/order/:idOrder/bias/:idBias/edit-subbias/:idSubBias'
                        element={<NewSubBiasForm edit />}
                    />

                    {/* Areas info */}
                    <Route exact path='/dashboard/areas' element={<Areas />} />

                    {/* New area */}
                    <Route
                        exact
                        path='/dashboard/areas/nueva-area'
                        element={<AreasForm />}
                    />

                    {/* Edit area */}
                    <Route
                        exact
                        path='/dashboard/areas/editar-area/:idArea'
                        element={<AreasForm edit />}
                    />

                    {/* Quotation engine */}
                    <Route
                        exact
                        path='/dashboard/cotizacion/:idQuotation'
                        element={<QuotationForm />}
                    />

                    {/* Ticket */}
                    <Route
                        exact
                        path='/dashboard/nuevo-ticket'
                        element={<NewTicketForm />}
                    />

                    {/* Production Plan */}
                    <Route
                        exact
                        path='/dashboard/plan-de-produccion'
                        element={<ProductionPlan />}
                    />

                    {/* Ticket Catalog */}
                    <Route
                        exact
                        path='/dashboard/tickets'
                        element={<TicketsCatalog />}
                    />

                    {/* Ticket Detail */}
                    <Route
                        exact
                        path='/dashboard/ticket/:id'
                        element={<TIcketDetail />}
                    />
                </Route>

                {/* Private Tracking */}
                <Route
                    exact
                    path='/tracking'
                    element={
                        <PrivateRoute
                            isAuthenticated={isLoggedIn}
                            bars={false}
                        />
                    }
                >
                    {/* Home Tracking */}
                    <Route
                        exact
                        path='/tracking/mis-pedidos'
                        element={<HomeTracking />}
                    />

                    {/* Page my orders */}
                    <Route
                        exact
                        path='/tracking/pedidos-tabla'
                        element={<MyOrders />}
                    />
                </Route>

                {/* Tracking */}
                <Route
                    exact
                    path='/tracking'
                    element={<PublicRoute isAuthenticated={isLoggedIn} />}
                >
                    {/* Authentication Tracking */}
                    <Route
                        exact
                        path='/tracking/inicio-de-sesion'
                        element={<LoginTracking />}
                    />

                    {/* Landing Page */}
                    <Route
                        exact
                        path='/tracking'
                        element={<LandingTracking />}
                    />
                    <Route path='*' element={<Navigate to='/' />} />
                </Route>
                {/* Public */}
                <Route
                    exact
                    path='/auth'
                    element={<PublicRoute isAuthenticated={isLoggedIn} />}
                >
                    {/* Authentication */}
                    <Route
                        exact
                        path='/auth/inicio-de-sesion'
                        element={<AuthComponent />}
                    />

                    {/* Clients (no auth required) */}
                    <Route
                        exact
                        path='/auth/nuevo-cliente'
                        element={<ClientsRegister />}
                    />
                    <Route path='*' element={<Navigate to='/' />} />
                </Route>
                <Route
                    path="/"
                    element={
                        isLoggedIn
                        ? <Navigate to="/dashboard/ordenes" />
                        : <Navigate to="/auth/inicio-de-sesion" />
                    }
                />
            </Routes>
        </Fragment>
    );
};
